module.exports = __webpack_public_path__ + "static/media/stage-1.4a725539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/DevelopingABrandCharacter/stage-1.jpg
// module id = 410
// module chunks = 0